module.exports = __webpack_public_path__ + "static/img/img_people.1776169966151.png";